import {createReducer, on} from '@ngrx/store';
import {NotificationActions} from './notification.actions';
import {initialState} from './notification.state';

export const notificationReducer = createReducer(
  initialState,

  on(NotificationActions.public.updateNotificationFilter, (state, {filter}) => ({
    ...state,
    filter: filter
  })),

  on(NotificationActions.public.loadLatestNotifications, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(NotificationActions.public.loadUnreadErrorNotifications, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(NotificationActions.private.loadNotificationsWithFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(NotificationActions.private.loadNotificationsSuccess, (state, {notificationsResponseDto}) => {
    const entities = {...state.entities};
    notificationsResponseDto.notifications.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities: entities,
      pages: {
        ...state.pages,
        [state.filter!!.page!!]: notificationsResponseDto.notifications.map((it) => it.id!!),
      },
      totalCount: notificationsResponseDto.totalCount,
      isLoading: false,
      error: null,
    };
  }),

  on(NotificationActions.private.loadNotificationsFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(NotificationActions.private.updateUnreadCount, (state, {unreadCount}) => ({
    ...state,
    unreadCount: unreadCount,
  })),

  on(NotificationActions.public.markAsRead, (state) => ({
    ...state,
    error: null,
  })),

  on(NotificationActions.private.markAsReadSuccess, (state, props) => {
    const entities = {...state.entities};
    entities[props.responseDto.id!!] = props.responseDto;

    return {
      ...state,
      entities: entities,
      error: null,
    }
  }),

  on(NotificationActions.private.markAsReadFailure, (state, props) => ({
    ...state,
    error: props.error,
  })),

  on(NotificationActions.public.markAllAsRead, (state) => ({
    ...state,
    error: null,
  })),

  on(NotificationActions.private.markAllAsReadSuccess, (state) => ({
    ...state,
    entities: Object.fromEntries(
      Object.entries(state.entities).map(([id, notification]) => [
        id,
        notification.readAt
          ? notification
          : {
              ...notification,
              readAt: new Date().toISOString(),
            },
      ])
    ),
    error: null,
  })),

  on(NotificationActions.private.markAllAsReadFailure, (state, props) => ({
    ...state,
    error: props.error,
  })),

  on(NotificationActions.public.deleteAll, (state) => ({
    ...state,
    error: null,
  })),

  on(NotificationActions.private.deleteAllSuccess, (state) => ({
    ...state,
    entities: {},
    pages: {},
    totalCount: 0,
    error: null,
  })),

  on(NotificationActions.private.deleteAllFailure, (state, props) => ({
    ...state,
    error: props.error,
  })),

  on(NotificationActions.private.loadNotificationsWithProvidedFiltersSuccess, (state, props) => {
    const entities = {...state.entities};
    props.responseDto.notifications.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities: entities,
      isLoading: false,
      error: null,
    };
  }),

  on(NotificationActions.private.loadNotificationsWithProvidedFiltersFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(NotificationActions.public.refreshNotificationDataFromWebSocket, (state, props) => {
    return {
      ...state,
    }
  }),
);
